import { render } from "./dialog-default.vue?vue&type=template&id=3daae86a&scoped=true"
import script from "./dialog-default.ts?vue&type=script&lang=js&external"
export * from "./dialog-default.ts?vue&type=script&lang=js&external"

import "./dialog-default.vue?vue&type=style&index=0&id=3daae86a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daae86a"]])

export default __exports__